import _ from "lodash";

export const addItem = (userId, key, value) => {
  let oldObject = JSON.parse(localStorage.getItem(userId));
  localStorage.setItem(
    userId,
    JSON.stringify(
      Object.assign(_.isEmpty(oldObject) ? {} : oldObject, { [key]: value })
    )
  );
};

export const getItem = (userId, key) => {
  return _.get(JSON.parse(localStorage.getItem(userId)), key, "");
};
